import { FormattedMessage } from 'react-intl'
import { Box, BoxProps, styled } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import Icon from 'assets/icons/icon-action-open-in-new.svg?react'
import { CardSize } from './CardSize'

type StyledContainerProps = BoxProps & { cardSize: CardSize }
const StyledContainer = styled(Box, { shouldForwardProp: (prop) => prop !== 'cardSize' })<StyledContainerProps>(
  ({ cardSize, theme }) => ({
    marginLeft: 'auto',
    marginRight: cardSize === 'large' ? theme.spacing(2.5) : theme.spacing(0.5),
    display: 'flex',
    alignSelf: cardSize === 'large' ? 'center' : 'flex-start',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      marginRight: theme.spacing(0.5),
      alignSelf: 'flex-start'
    }
  })
)

const GoToText = styled(Typography)(({ theme }) => ({
  display: 'block',
  textAlign: 'right',
  minWidth: theme.spacing(8),
  marginRight: theme.spacing(0.5),
  color: theme.palette.primary.main,
  [theme.breakpoints.down('md')]: {
    display: 'none'
  }
}))

const OpenInNewIcon = styled(Icon, {
  shouldForwardProp: (prop) => prop !== 'cardSize'
})<StyledContainerProps>(({ cardSize, theme }) => ({
  width: theme.spacing(2.25),
  height: theme.spacing(2.25),
  '& path': {
    fill: cardSize === 'large' ? theme.palette.primary.main : theme.palette.grey[200]
  }
}))

export default function HomeAppCardGoTo({ cardSize }: { cardSize: CardSize }) {
  if (cardSize === 'small') return null
  return (
    <StyledContainer cardSize={cardSize}>
      {cardSize === 'large' && (
        <GoToText variant="caption">
          <FormattedMessage id="home.apps.card.goToApp" />
        </GoToText>
      )}
      <OpenInNewIcon cardSize={cardSize} />
    </StyledContainer>
  )
}
